import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { DrawersModule } from '@shared/drawers';
import  { FiltersDrawerModule } from '@shared/drawers/filters/filters-drawer.module';
import { PipesModule } from '@shared/pipes';
import { UserMenuComponent } from './common/user-menu/user-menu.component';
import { AvisosComponent } from './components/avisos/avisos.component';
import { BasicItemComponent } from './components/basic/basic-item.component';
import { CollapsableItemComponent } from './components/collapsable/collapsable-item.component';
import { HeaderComponent } from './components/header/header.component';
import { NotificacionesComponent } from './components/notificaciones/notificaciones.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { YaloAppsComponent } from './components/yalo-apps/yalo-apps.component';
import { LayoutComponent } from './layout.component';
import { EmptyComponent } from './layouts/empty/empty.component';
import { MainComponent } from './layouts/main/main.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AppbarComponent } from '@app/layout/components/appbar/appbar.component';

@NgModule({
  declarations: [
    LayoutComponent,
    EmptyComponent,
    MainComponent,
    HeaderComponent,
    NotificacionesComponent,
    SidebarComponent,
    UserMenuComponent,
    ProfileComponent,
    AvisosComponent,
    YaloAppsComponent,
    CollapsableItemComponent,
    BasicItemComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    PipesModule,
    DrawersModule,
    FiltersDrawerModule,
     ScrollingModule,
    AppbarComponent,
  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule { }
